import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { CorrectiveAction } from '../../../../models/corrective-action.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  EditListModalBase,
  EditListSchema,
} from '../../../../shared/bases/edit-list-modal.base';

@Component({
  selector: 'app-edit-corrective-actions-modal',
  templateUrl: './edit-corrective-actions-modal.component.html',
  styleUrls: ['./edit-corrective-actions-modal.component.scss'],
  standalone: false,
})
export class EditCorrectiveActionsModalComponent extends EditListModalBase<CorrectiveAction> {
  @Output() onSubmitForm = new EventEmitter<any>();
  @Output() onCancelForm = new EventEmitter<void>();

  constructor(
    fb: FormBuilder,
    confirmationService: ConfirmationService,
    private messageService: MessageService,
  ) {
    super(
      fb,
      {
        arrayName: 'correctiveActions',
        confirmDeleteHeader: 'Confirmation de suppression',
        confirmDeleteMessage:
          'Êtes-vous sûr de vouloir supprimer ce travail correctif?',
      } as EditListSchema<CorrectiveAction>,
      confirmationService,
    );
  }

  onSubmit(): void {
    if (!this.isFormValid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: this.validationMessage,
      });
      return;
    }
    this.onSubmitForm.emit(this.buildSubmitResult());
    this.closeModal();
  }

  onCancel(): void {
    this.onCancelForm.emit();
    this.closeModal();
  }
}
